/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'

import PropTypes from 'prop-types'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import constants from 'constants/index'

const AcceptanceReportPdf = ({
  exportingPdf,
  setExportingPdf,
  data = {},
  refresh = () => {},
  shouldCreateVersion = false,
  consentFormId,
}) => {
  const snackbar = useSnackbar()

  const { EXPORT_FORMAT_TYPES } = constants.reports

  useEffect(() => {
    const generateReport = () => {
      try {
        const isAll = data?.documentVersionId === 'all'

        service.dponet.consent.consentFormAcceptanceExportReport({
          consentFormId,
          ...(!isAll && {
            documentVersion: data?.documentVersionId,
          }),
          kind: constants.reportVersions.KIND.ACCEPTANCE,
          shouldCreateVersion,
          exportFormat: EXPORT_FORMAT_TYPES.PDF,
        })

        snackbar.open({
          message: 'O relatório será gerado e enviado por e-mail!',
          variant: 'success',
        })
        refresh()
      } catch (error) {
        snackbar.open({
          message: 'Houve um erro durante o processamento de dados.',
          variant: 'error',
        })
      } finally {
        setExportingPdf(false)
      }
    }
    if (exportingPdf) {
      generateReport()
    }
  }, [exportingPdf])

  return <></>
}

AcceptanceReportPdf.propTypes = {
  exportingPdf: PropTypes.bool.isRequired,
  setExportingPdf: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  refresh: PropTypes.func,
  shouldCreateVersion: PropTypes.bool,
}

export default AcceptanceReportPdf
